import _ from 'lodash';

import sourceFields from '../../constants/sourcesFields';

const state = {
  allSourceFields: null,
};

const getters = {
  getSourceBySourceName: state => (sourceName => _.find(state.allSourceFields, { sourceName })),
  getSourceByBackendName: state => (backendName => _.find(state.allSourceFields, { backendName })),
  getSourceByKey: state => (key => state.allSourceFields[key]),
  sourceFieldsWithBaseDiscount: state => {
    if (!state.allSourceFields) {
      return null;
    }
    const allSourceFieldsCloned = _.cloneDeep(state.allSourceFields);
    allSourceFieldsCloned.discount.hidden = true;
    allSourceFieldsCloned['discount-api'].hidden = true;
    allSourceFieldsCloned.baseDiscount = {
      sourceName: 'דיסקונט בסיס',
      displayName: 'דיסקונט',
      backendName: 'DiscountBase',
      logoFile: 'discount-large.svg',
      type: 'bank',
      sortPriority: 10,
    };
    const bankArray = _.filter(allSourceFieldsCloned, source => source.type === 'bank' && !source.hidden);
    return _.sortBy(bankArray, b => b.sortPriority);
  },
};

const actions = {
  initSourceFields({ commit }) {
    if (!state.allSourceFields) {
      commit('setSourceFields', sourceFields.allSourceFields);
    }
  },
};

const mutations = {
  setSourceFields(state, sourceFields) {
    state.allSourceFields = sourceFields; // eslint-disable-line
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
